import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import "./login.css";
import { SERVER_HIT } from "../../util/API";
import axios from "axios";

const Login = ({
  userLoggedIn
}) => {
  const [inputUsername, setInputUsername] = useState("");
  const [inputPassword, setInputPassword] = useState("");

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    const { status, data } = await SERVER_HIT.post('?module=user&operation=authenticate_user', {
      username: inputUsername,
      password: inputPassword,
    });
    if (status === 200) {
      if (data.code === 'authentication_failed') {
        setShow(true);
      } else if (data.code === 'authentication_success') {
        localStorage.setItem('CBisLoggedIn', true);
        localStorage.setItem('CBssnid', data.session_id);
        localStorage.setItem('CBusername', inputUsername);
        userLoggedIn();
      }
    }
    setLoading(false);
  };

  const handlePassword = () => {};

  return (
    <div
      className="sign-in__wrapper"
    >
      {/* Overlay */}
      <div className="sign-in__backdrop"></div>
      {/* Form */}
      <Form className="shadow p-4 bg-white rounded" onSubmit={handleSubmit}>
        {/* Header */}
        <div className="h4 mb-2 text-center">Sign In</div>
        {/* ALert */}
        {show ? (
          <Alert
            className="mb-2"
            variant="danger"
            onClose={() => setShow(false)}
            dismissible
          >
            Incorrect username or password.
          </Alert>
        ) : (
          <div />
        )}
        <Form.Group className="mb-2" controlId="username">
          <Form.Label>Username</Form.Label>
          <Form.Control
            type="text"
            value={inputUsername}
            placeholder="Username"
            onChange={(e) => setInputUsername(e.target.value)}
            required
          />
        </Form.Group>
        <Form.Group className="mb-4" controlId="password">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            value={inputPassword}
            placeholder="Password"
            onChange={(e) => setInputPassword(e.target.value)}
            required
          />
        </Form.Group>
        <Button className="w-100" variant="primary" type="submit" disabled={loading}>
          { loading ? 'Logging In...' : 'Log In'}
        </Button>
      </Form>
    </div>
  );
};

export default Login;
